import { render, staticRenderFns } from "./DocumentPageSelector.vue?vue&type=template&id=cc2e56ae&scoped=true&"
import script from "./DocumentPageSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageSelector.vue?vue&type=style&index=0&id=cc2e56ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2e56ae",
  null
  
)

export default component.exports